import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "gold" | "danger";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  iconOnly?: boolean;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
}

const variantClass: Record<ButtonVariant, string> = {
  primary: "",
  secondary: "fd-btn--secondary",
  ghost: "fd-btn--ghost",
  gold: "fd-btn--gold",
  danger: "fd-btn--danger",
};

const sizeClass: Record<ButtonSize, string> = {
  sm: "fd-btn--sm",
  md: "",
  lg: "fd-btn--lg",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = "primary",
    size = "md",
    iconOnly = false,
    leadingIcon,
    trailingIcon,
    className,
    children,
    ...rest
  },
  ref
) {
  const cls = [
    "fd-btn",
    variantClass[variant],
    sizeClass[size],
    iconOnly && "fd-btn--icon",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button ref={ref} className={cls} {...rest}>
      {leadingIcon}
      {children}
      {trailingIcon}
    </button>
  );
});
